module.exports = __webpack_public_path__ + "static/media/produto-sem-imagem-1.2ccfb507.gif";